import { createFileRoute } from "@tanstack/react-router";
import { ExerciseDetail } from "@/components/exercise-detail";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/management/exercises/new/")({
  component: RouteComponent,
  loader: () => ({ hasActionButtons: true }),
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer className="mt-0">
      <div className="flex min-h-full flex-col px-6 md:px-6 lg:py-2">
        <MobilePageTitle className="mt-5 mb-4">
          {t("pages:exercise.newExercise")}
        </MobilePageTitle>
        <ExerciseDetail />
      </div>
    </ScrollableContainer>
  );
}
